import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.05 4.507a3.656 3.656 0 0 1 1.776 2.139 3.781 3.781 0 0 1-.215 2.803 3.64 3.64 0 0 1-.861 1.123 3.5 3.5 0 0 1-1.212.695c-.32.098-.65.156-.984.173.258.214.49.46.693.732.276.388.475.83.584 1.3a3.773 3.773 0 0 1-.428 2.777c-.245.41-.567.766-.946 1.047-.767.573-1.721.81-2.656.66a3.574 3.574 0 0 1-2.336-1.464c-.2-.28-.359-.59-.471-.919a3.592 3.592 0 0 1-.458.919A3.574 3.574 0 0 1 6.2 17.956a3.497 3.497 0 0 1-2.655-.66 3.599 3.599 0 0 1-.947-1.047 3.77 3.77 0 0 1-.428-2.777c.11-.47.308-.912.584-1.3.202-.272.435-.518.694-.732a4.032 4.032 0 0 1-.999-.173 3.52 3.52 0 0 1-1.208-.702 3.66 3.66 0 0 1-.856-1.128 3.798 3.798 0 0 1-.21-2.806c.145-.459.376-.884.68-1.25a3.573 3.573 0 0 1 1.089-.887 3.438 3.438 0 0 1 2.71-.217c.321.099.625.249.901.445a4.018 4.018 0 0 1-.139-1.019 3.77 3.77 0 0 1 1.048-2.618A3.517 3.517 0 0 1 8.994 0c.948 0 1.858.39 2.53 1.085a3.77 3.77 0 0 1 1.047 2.618 4.018 4.018 0 0 1-.139 1.02c.277-.192.581-.337.902-.431a3.454 3.454 0 0 1 2.716.215ZM9 13c1.657 0 3-1.567 3-3.5S10.657 6 9 6 6 7.567 6 9.5 7.343 13 9 13Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }